import React from "react";
import { Props } from "./types";
import { ToggleArrow } from "./toggleArrow";
import styles from "./styles.scss";
import classNames from "classnames";

function CloseLast({ isDisabled, toggle }: Props) {
  return (
    <div
      className={classNames(styles.closeLast, {
        [styles.disabled]: isDisabled,
      })}
      onClick={toggle}
    >
      <ToggleArrow className={styles.toggleArrow} />
    </div>
  );
}

export { CloseLast };
